'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weeksFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/weeksFromNow.js
// module id = 392
// module chunks = 1